import { memo } from 'react';
import * as S from './CardViewMore.styles';
import Link from 'next/link';
import { IPartnersInfoDestination } from '@/common/service/api/Partners/Partners.domain';

const CardViewMoreContainer = ({ destination }: { destination: IPartnersInfoDestination }) => {
    return (
        <S.ViewMoreDesktop data-test-id="View_more">
            <S.TextWrapper>
                <S.SelectedTitle>{destination.name}</S.SelectedTitle>
                <S.SelectedExperience>
                    {destination.count_experiences} Experiences
                </S.SelectedExperience>
            </S.TextWrapper>
            <S.ButtonWrapper data-test-id="View_more_btn">
                <Link href={destination.link} passHref>
                    <S.Button>
                        <span>All {destination.name} Partners</span>
                    </S.Button>
                </Link>
            </S.ButtonWrapper>
        </S.ViewMoreDesktop>
    );
};

export const CardViewMore = memo(CardViewMoreContainer);
